module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1017-a3e91ce9f8f46424d4c54e4997f1f1a8.png";